import { Box, Button, Tooltip } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useEffect } from "react";
import { clearImpersonateAndReturnToCs } from "../../../../../functions/handleImpersonateAccount";
import {
  HALO_GRADIENT,
  OMBRE_GRADIENT,
} from "@features/impersonation-feature/constants";
import { ImpersonationPanel } from "./Panel/ImpersonationPanel";
import { telemetryProps } from "shared-ui/src/instrumentation/gtm";
import { useUnifiedNav } from "@features/unified-side-nav-feature/context/UnifiedNavContext";
import { useImpersonationOrigin } from "@features/impersonation-feature/hooks/useImpersonationOrigin";

export default function ImpersonationBar() {
  const {
    setImpersonationState,
    cancelImpersonationCollapsePersistence,
  } = useUnifiedNav();
  const origin = useImpersonationOrigin();

  useEffect(() => {
    if (origin == null) {
      return;
    }

    setImpersonationState((prev) => {
      if (prev.current != null) {
        return prev;
      }

      return {
        ...prev,
        current: origin,
        pending: null,
      };
    });
  }, [origin, setImpersonationState]);

  const exitImpersonation = () => {
    cancelImpersonationCollapsePersistence();
    clearImpersonateAndReturnToCs();
  };

  return (
    <Box
      id="impersonation-bar-region"
      role="region"
      aria-label="Impersonation controls"
      sx={{
        width: "100%",
        background: OMBRE_GRADIENT,
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr auto 1fr" },
          alignItems: "center",
          justifyItems: { xs: "stretch", md: "initial" },
          px: { xs: 1, sm: 2 },
          py: { xs: 1, sm: 0.75 },
          minHeight: (theme) => theme.spacing(6),
          gap: { xs: 1.25, md: 1 },
        }}
      >
        {/* ── Left: My Accounts — hidden below md ── */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            justifyContent: "flex-start",
          }}
        >
          <Tooltip
            title="Exit impersonation and return back to my accounts."
            placement="bottom"
          >
            <Button
              {...telemetryProps({
                name: "impersonation_back_to_accounts",
                section: "impersonation_panel",
                label: "Back to My Accounts",
              })}
              variant="outlined"
              color="primary"
              size="small"
              startIcon={<ExitToAppIcon fontSize="small" />}
              onClick={exitImpersonation}
            >
              Back to My Accounts
            </Button>
          </Tooltip>
        </Box>
        <ImpersonationPanel origin={origin} />
      </Box>
      {/* Bottom gradient border */}
      <Box
        sx={{
          height: (theme) => theme.spacing(0.5),
          background: HALO_GRADIENT,
        }}
      />
    </Box>
  );
}
